import { ruleTriggerOptions } from '../queries';
import { useQuery } from 'react-apollo';

export function useRuleTriggerOptions () {
  const { data: query , refetch: refresh, loading: isLoading, error } = useQuery(ruleTriggerOptions, {
    fetchPolicy: 'cache-first',
  });
  let data = (query?.ruleTriggerOptions || []).map(row => ({
		id: row.dbId,
    name: row.name,
    ruleTrigger: row.ruleTrigger
  }));
  if (error) {
    data = [{
      'id':29,
      'name':'Draft',
      'ruleTrigger':3,
    },{
      'id':30,
      'name':'Awaiting TI Feedback',
      'ruleTrigger':3,
    },{
      'id':31,
      'name':'TI Feedback Provided',
      'ruleTrigger':3,
    },{
      'id':32,
      'name':'Awaiting TI Verification',
      'ruleTrigger':3,
    },{
      'id':33,
      'name':'Awaiting Funder Feedback',
      'ruleTrigger':3,
    },{
      'id':34,
      'name':'Funder Feedback Provided',
      'ruleTrigger':3,
    },{
      'id':35,
      'name':'Awaiting Funder Verification',
      'ruleTrigger':3,
    },{
      'id':36,
      'name':'Published',
      'ruleTrigger':3,
    },{
      'id':37,
      'name':'Finalized',
      'ruleTrigger':3,
    },{
      'id':38,
      'name':'Initial',
      'ruleTrigger':4,
    },{
      'id':39,
      'name':'Interim',
      'ruleTrigger':4,
    },{
      'id':40,
      'name':'Final',
      'ruleTrigger':4,
    },{
      'id':41,
      'name':'Allocate',
      'ruleTrigger':5,
    },{
      'id':42,
      'name':'Draft',
      'ruleTrigger':5,
    },{
      'id':43,
      'name':'Awaiting TI Feedback',
      'ruleTrigger':5,
    },{
      'id':44,
      'name':'Awaiting TI Verification',
      'ruleTrigger':5,
    },{
      'id':45,
      'name':'Awaiting Funder Feedback',
      'ruleTrigger':5,
    },{
      'id':46,
      'name':'Awaiting Funder Verification',
      'ruleTrigger':5,
    },{
      'id':47,
      'name':'Published',
      'ruleTrigger':5,
    },{
      'id':48,
      'name':'Finalized',
      'ruleTrigger':5,
    },{
      'id':49,
      'name':'Interim',
      'ruleTrigger':5,
    },{
      'id':50,
      'name':'Final',
      'ruleTrigger':5,
    },{
      'id':74,
      'name':'Complete Interim Updates',
      'ruleTrigger':5,
    },{
      'id':51,
      'name':'Draft',
      'ruleTrigger':8,
    },{
      'id':52,
      'name':'Awaiting TI Feedback',
      'ruleTrigger':8,
    },{
      'id':53,
      'name':'TI Feedback Provided',
      'ruleTrigger':8,
    },{
      'id':54,
      'name':'Awaiting TI Verification',
      'ruleTrigger':8,
    },{
      'id':55,
      'name':'Awaiting Funder Feedback',
      'ruleTrigger':8,
    },{
      'id':56,
      'name':'Funder Feedback Provided',
      'ruleTrigger':8,
    },{
      'id':57,
      'name':'Awaiting Funder Verification',
      'ruleTrigger':8,
    },{
      'id':58,
      'name':'Published',
      'ruleTrigger':8,
    },{
      'id':59,
      'name':'Finalized',
      'ruleTrigger':8,
    },{
      'id':60,
      'name':'Initial',
      'ruleTrigger':9,
    },{
      'id':61,
      'name':'Interim',
      'ruleTrigger':9,
    },{
      'id':62,
      'name':'Final',
      'ruleTrigger':9,
    },{
      'id':63,
      'name':'Allocate Report',
      'ruleTrigger':10,
    },{
      'id':64,
      'name':'Draft Due',
      'ruleTrigger':10,
    },{
      'id':65,
      'name':'Enter TI Feedback',
      'ruleTrigger':10,
    },{
      'id':66,
      'name':'Resolve TI Feedback',
      'ruleTrigger':10,
    },{
      'id':67,
      'name':'Enter Funder Feedback',
      'ruleTrigger':10,
    },{
      'id':68,
      'name':'Resolve Funder Feedback',
      'ruleTrigger':10,
    },{
      'id':69,
      'name':'Publish Report',
      'ruleTrigger':10,
    },{
      'id':70,
      'name':'Finalize Report',
      'ruleTrigger':10,
    },{
      'id':71,
      'name':'Interim Report Stage',
      'ruleTrigger':10,
    },{'id':72,'name':'Final Report Stage','ruleTrigger':10},{'id':73,'name':'Notify Grantee','ruleTrigger':10}];
  }
  return {
    data,
    refresh,
    isLoading
  };
}
